import * as React from 'react';
import { Tooltip } from '@mui/material';
import AppButton from '../../AppButton';

interface WaitingListSmsButtonProps {
    label: string;
    tooltip: string;
    hasClientId: boolean;
    hasClientPhone: boolean;
    onClick: () => void;
}

const WaitingListSmsButton: React.FC<WaitingListSmsButtonProps> = ({
    label,
    tooltip,
    hasClientId,
    hasClientPhone,
    onClick,
}) => {
    const disabled = !hasClientId || !hasClientPhone;

    return (
        <Tooltip title={tooltip} placement="top">
            <span>
                <AppButton
                    color="secondary"
                    size="sm"
                    disabled={disabled}
                    onClick={onClick}
                >
                    {label}
                </AppButton>
            </span>
        </Tooltip>
    );
};

export default WaitingListSmsButton;
